import React from 'react';
import { Tag } from 'antd';
import styles from "./contacts.module.css";
import { TG, BOT, COLORS, getLink } from '../../../constants';

const CHANNELS = [
  {
    id: '01',
    tierClass: styles.tierBlock,
    iconClass: styles.iconPink,
    accent: COLORS.accentPink,
    title: 'Группа клуба',
    description: 'Приходите на встречи клуба. Сейчас есть набор только в новую группу.',
    terminal: '> slot.status: FULL // набор в новую группу',
    status: { text: 'FULL', color: 'default' },
    button: { text: 'Telegram бот для записи', href: getLink(BOT.startProps.club), variant: 'pink' },
    svg: (
      <svg width="40" height="40" viewBox="64 64 896 896" fill={COLORS.accentPink} opacity="0.9" xmlns="http://www.w3.org/2000/svg">
  <path d="M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"></path>
</svg>
    ),
  },
  {
    id: '02',
    tierClass: styles.tierGroup,
    iconClass: styles.iconBlue,
    accent: COLORS.accentCyan,
    title: 'Своя группа',
    description: 'Собирайтесь с друзьями или коллегами.',
    terminal: '> handshake: OPEN // ping masha',
    status: { text: 'ONLINE', color: 'cyan' },
    button: { text: 'Обсудить в Telegram', href: TG.link, variant: 'blue' },
    svg: ( 
      <svg width="40" height="40" viewBox="64 64 896 896" focusable="false" data-icon="home" fill={COLORS.accentCyan} aria-hidden="true"><path d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"></path></svg>
    ),
  },
  {
    id: '03',
    tierClass: styles.tierIndividual,
    iconClass: styles.iconGreen,
    accent: COLORS.accentGreen,
    title: 'Индивидуально',
    description: 'Личная встреча с обсуждением вашей книги. Без людей, не нужно ждать группу.',
    terminal: '> bot.masha: ACTIVE // direct line',
    status: { text: 'BOT', color: 'green' },
    button: { text: 'Telegram бот для записи', href: getLink(BOT.startProps.mentoring), variant: 'green' },
    svg: (
      <svg width="40" height="40" viewBox="64 64 896 896" fill={COLORS.accentGreen} xmlns="http://www.w3.org/2000/svg">
        <path d="M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z"></path>
      </svg>
    ),
  },
];

export const SectionContacts = () => {
  return (
    <section className={styles.sectionContactsContainer} id='contacts'>
      <div className={styles.sectionContactsWrap}>
        <h2 className={styles.sectionContactsTitle}>
          <span className={styles.titleMain}>Записаться</span>
          <span className={styles.titleSubtitle} hidden>Что куда писать</span>
        </h2>
        <p className={styles.sectionContactsSubtitle} hidden>
          Всё в телеге
        </p>

        <div className={styles.sectionContactsInfoContainer}>
          {CHANNELS.map((channel) => (
            <article
              key={channel.id}
              className={`${styles.sectionContactsInfoCard} ${channel.tierClass}`}
            >
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />

              <header className={styles.cardHeader}>
                <span className={styles.channelId}>{channel.id}</span>
                <Tag
                  hidden
                  bordered={false}
                  color={channel.status.color}
                  className={styles.statusTag}
                >
                  {channel.status.text}
                </Tag>
              </header>

              <div className={`${styles.sectionContactsInfoCardIcon} ${channel.iconClass}`}>
                {channel.svg}
              </div>

              <div className={styles.sectionContactsInfoCardTextWrap}>
                <h3 className={styles.sectionContactsInfoCardTg}>{channel.title}</h3>
                <p className={styles.tierDescription}>{channel.description}</p>
                <p hidden className={styles.terminalLine}>{channel.terminal}</p>
              </div>

              {channel.button.disabled ? (
                <span className={`${styles.tierButton} ${styles.tierButtonDisabled}`}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={COLORS.textMuted} strokeWidth="2">
                    <path d="M12 4l-1 8-6 3 6 3-1 8 6-4 6 4-1-8-6-3z" />
                  </svg>
                  {channel.button.text}
                </span>
              ) : (
                <a
                  href={channel.button.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.tierButton} ${channel.button.variant === 'blue' ? styles.tierButtonBlue : channel.button.variant === 'pink' ? styles.tierButtonPink : styles.tierButtonGreen}`}
                > 
                  <span className={styles.tierButtonText}>{channel.button.text}</span>
                  <span className={styles.tierButtonArrow} aria-hidden="true">→</span>
                </a>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
